$.fn.menu = function() {
  const main = $(this);
  const menuItems = main.find('ul:first > li');
  const mobileMenuItems = main.find('ul:first > li > a');
  const activeMenuItem = menuItems.filter('.active');
  const activeSubMenu = activeMenuItem.find('.subMenu');
  const inline = main.find('.inline:first');
  const subMenus = main.find('.subMenu');

  const menuItemA = main.find('a');
  menuItemA.on('click', function(e) {
  const href = $(this).attr('href');
    if(href.length === 0){
      e.preventDefault();
    }
  });

  activeSubMenu.show();

  menuItems.on('mouseenter focusin', function() {
    if ($('.header-mobile').is(':visible')) { return false; }
    const elem = $(this);
    showMenu(elem);
  });

  menuItems.on('mouseleave focusout', function() {
    if ($(window).width() < 1000) { return false; }
    const elem = $(this);
    hideMenu(elem);
  });
  
  mobileMenuItems.on('click', function(e) {
    if ($('.header-mobile').is(':visible')) {
      const elem = $(this);
      if (elem.parent().hasClass('active')) {
        activeSubMenu.hide();
        activeMenuItem.removeClass('active');
        menuItems.removeClass('active');
        main.find('.subMenu').hide();
      } else if (elem.parent().find('.subMenu').length ) {
        e.preventDefault();
        showMenu(elem.parent(), true);
      }
    }
  });

  function showMenu(elem, isMobile) {
    if (isMobile) {
      menuItems.each(function() {
        hideMenu($(this));
      });
    }

    activeSubMenu.hide();
    activeMenuItem.removeClass('active');
    const hoverSub = elem.find('.subMenu:first');

    if (hoverSub.length) {
      elem.find('.subMenu:first').show();
      elem.addClass('active');
    } else {
      elem.find('.subMenu:first').show();
      elem.addClass('active');
      if (!activeMenuItem.length) {
        inline.removeAttr('style');
      }
    }
  }

  function hideMenu(elem){
    elem.find('.subMenu:first').hide();
    elem.removeClass('active');
    activeSubMenu.show();
    activeMenuItem.addClass('active');
    calculateHeights();
  }

  function calculateHeights() {
    if (activeMenuItem.length) {
      main.removeAttr('style');

      const top = main.outerHeight();
      subMenus.css({
        top: top
      });
      const height = main.outerHeight() + activeMenuItem.find('.subMenu').outerHeight();
      main.css({
        height: height,
      });
    }
  }

  calculateHeights();
  $(window).on('resize:menu', function(){
    calculateHeights();
  });
}